module.exports = __webpack_public_path__ + "static/media/light_info_icon.58592f57.svg";